// extracted by mini-css-extract-plugin
module.exports = {"slider":"ItemsSlider__slider--1wK","sliderContainer":"ItemsSlider__sliderContainer--2Bn","slide":"ItemsSlider__slide--2iO"};